<template>
  <div class="aftersale-detail">
    <!--    save  保存-->
    <!--    back  确认退回-->
    <div style="padding-bottom:15px;">
      <el-page-header @back="goBack" content="详情页面"></el-page-header>
    </div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>买家信息</span>
      </div>
      <div class="text item">
        <ul>
          <li class="mgb15">账号ID/微信名称：{{ detailData.afterSaleName }}</li>
          <li class="mgb15">手机号码：{{ detailData.afterSaleMobile }}</li>
          <li class="mgb15">商品名称：{{
              orderDetail.orderItems && orderDetail.orderItems[0] &&
              orderDetail.orderItems[0].productSkuName
            }}
          </li>
          <li class="mgb15">子订单号：{{ detailData.orderNo }}</li>
          <li>下单时间：{{ detailData.creationTime }}</li>
          <!-- <li>换货地址：姓名/手机号/详细地址</li> -->
        </ul>
      </div>
    </el-card>
    <!--    <el-card class="box-card">-->
    <!--      <div slot="header" class="clearfix">-->
    <!--        <span>换货人信息</span>-->
    <!--      </div>-->
    <!--      <div class="text item">-->
    <!--        <ul>-->
    <!--          <li class="mgb15">-->
    <!--            <span>换货人姓名：换货</span>-->
    <!--            <span>换货人电话：换货</span>-->
    <!--          </li>-->
    <!--          <li class="mgb15">换货地址：17828282822</li>-->
    <!--        </ul>-->
    <!--      </div>-->
    <!--    </el-card>-->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>申请信息</span>
      </div>
      <div class="text item">
        <ul>
          <li class="mgb15">售后类型：退货</li>
          <li class="mgb15">购买数量：{{
              detailData.afterSaleQuantity
            }}
          </li>
          <li class="mgb15">实付金额：{{
              payTotalAccount
            }}
          </li>
          <!-- 退款 -->
          <li class="mgb15">
            <span class="mgr40">申请退款数量：{{ detailData.afterSaleQuantity }}</span>
            <span class="mgr40">申请退款金额：￥{{ detailData.afterSaleAmount }}</span>
            <span>退款状态：{{ detailData.afterSaleType == 1 ? '退款' : detailData.afterSaleType == 2 ? '退货' : '换货' }}</span>
          </li>
          <!-- 退货 -->
          <!--          <li class="mgb15">-->
          <!--            <span class="mgr40">申请退货数量：22</span>-->
          <!--            <span class="mgr40">申请退货金额：￥22</span>-->
          <!--            <span>退款状态：￥22</span>-->
          <!--          </li>-->
        </ul>
      </div>
    </el-card>
    <el-card>
      退货
      <div>
        <el-table :data="tableData" border>
          <el-table-column prop="orderAfterSaleNo" label="售后单号" align="center"></el-table-column>
          <el-table-column prop="supllierName" label="供应商名称" align="center"></el-table-column>
          <el-table-column prop="afterSaleQuantity" label="所需退货数量" align="center"></el-table-column>
          <el-table-column prop="afterSaleAmount" label="所需退货金额" align="center"></el-table-column>
          <el-table-column label="退回状态" align="center">
            <template slot-scope="scope">
              {{ scope.row.isReturn ? '已退回' : '未退回' }}
            </template>
          </el-table-column>
          <el-table-column prop="orderAfterSaleNo" label="确认退回" align="center">
            <template slot-scope="scope">
              <el-button v-if="isShowBack && !scope.row.isReturn" @click="back(scope.row)" type="primary" size="mini">
                确认退回
              </el-button>
              <span v-else>无需操作</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="padding-top:10px;">
        <div style="margin-bottom:10px;">备注</div>
        <p></p>
        <el-input :autosize="{ minRows: 2}" style="width:500px;" v-model="remark" type="textarea"></el-input>
      </div>
      <div class="btn-box">
        <el-button v-if="isShowSave" type="primary" @click="save">确认</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  OrderAfterSaleGetAll,
  OrderAfterSaleGet, OrderAfterSaleUpdate, ConfirmReturn, OrderPurchaseGet
} from '../../../api/api'
import {getButtonList} from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar"

export default {
  components: {Toolbar},
  data() {
    return {
      tableData: [],
      isShowBack: false,
      isShowSave: false,
      buttonList_toolBar: [],
      buttonList_table: [],
      id: null,
      detailData: {},
      remark: '',
      orderDetail: {},
      orderList: [],
      payTotalAccount: null,
    }
  },
  mounted() {
    let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
      console.log('this.buttonList_table', this.buttonList_table);
      this.buttonList_table && this.buttonList_table.forEach((item, index) => {
        if (item.buttonFunc === 'back') {
          this.isShowBack = true
        }
      })

      this.buttonList_table && this.buttonList_table.forEach((item, index) => {
        if (item.buttonFunc === 'save') {
          this.isShowSave = true
        }
      })
    }
  },
  created() {
    console.log('created');
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.orderId = this.$route.query.orderId;
      console.log('审核退款', this.id, this.orderId);
      this.getDetail(this.$route.query.id)
      this.getOrderDetail()
    } else {
      return this.$message.error('缺少售后单Id,参数缺失')
    }

  },
  methods: {
    getOrderDetail() {
      OrderPurchaseGet({id: this.orderId}).then(res => {
        if (res.data.success) {
          this.orderDetail = res.data.result || {}
          this.payTotalAccount = res.data.result.payTotalAccount || null
          console.log('orderDetail', res);
          this.orderList = res.data.result.orderPurchases || []
          this.orderList.forEach(item => {
            item.supllierId = null
            item.supllierName = null
          })
        } else {
          this.$message.error(res.data.error.message);
        }
      })
    },
    save() {
      this.$confirm("确认提交保存吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(async () => {
        let params = {};
        params.id = this.detailData.id;
        params.remark = this.remark;
        params.orderAfterSaleId = this.detailData.id;
        console.log('savbe', params)
        let res = await OrderAfterSaleUpdate(params);
        console.log('---', res);
        if (res.data.success) {
          this.$message.success(res.data.msg || '保存成功');
          await this.getDetail();
        } else {
          this.$message.error(res.data.error.message || '保存失败, 请重试');
        }
      }).catch(() => {
      });
    },
    async getDetail() {
      let res = await OrderAfterSaleGet({id: this.id})
      console.log('res', res);
      if (res.data.success) {
        const {orderAfterSaleDetails} = res.data.result;
        const {orderAfterSaleNo} = res.data.result;
        const {afterSaleAmount} = res.data.result;
        const {afterSaleRemark} = res.data.result;
        this.remark = afterSaleRemark;
        console.log('orderAfterSaleNo', orderAfterSaleNo);
        orderAfterSaleDetails && orderAfterSaleDetails.forEach(item => {
          item.orderAfterSaleNo = orderAfterSaleNo
          item.afterSaleAmount = afterSaleAmount
        })
        console.log('orderAfterSaleDetails', orderAfterSaleDetails);
        this.tableData = orderAfterSaleDetails || [];
        this.detailData = res.data.result || {};
        // "orderId": 42,
        //     "orderNo": "20220422124731729043",
        //     "outOrderNo": "20220422124731729043",
        //     "orderAfterSaleNo": "20220422125201681420",
        //     "outOrderAfterSaleNo": "503783",
        //     "afterSaleType": 2,
        //     "afterSaleQuantity": 1,
        //     "afterSaleAmount": 0.02,
        //     "reason": "商品质量有问题",
        //     "afterSaleStatus": 1,
        //     "afterSaleName": "河南周口",
        //     "afterSaleMobile": "17309633172",
        //     "orderAfterSaleDetails": [],
        //     "order": null,
        //     "afterSaleRemark": 0,
        //     "id": 7
        // this.tableData.orderAfterSaleNo
        //  this.tableData = [];
        //  let params = {};
        //  params.orderAfterSaleNo = this.detailData.orderAfterSaleNo;
        //  // params.orderAfterSaleNo = this.detailData.order.orderAfterSaleNo;
        //  params.afterSaleQuantity = this.detailData.afterSaleQuantity;
        //  params.afterSaleAmount = this.detailData.afterSaleAmount;
        //  params.afterSaleStatus = this.detailData.afterSaleStatus;
        //  params.id = this.detailData.orderId;
        // this.tableData.push(params);
        //  console.log('this.tableData',this.tableData);
      } else {
        this.$message.error(res.data.error || '获取失败,请重试')
      }

    },
    goBack() {
      this.$router.go(-1);
    },
    back(row) {
      console.log('退回', row);
      this.$confirm("确认退回吗?", "提示", {
        closeOnClickModal: false,
        type: 'warning'
      })
          .then(async () => {
            let res = await ConfirmReturn({id: row.id});
            if (res.data.success) {
              this.$message.success(res.data.msg || '退回成功');
              await this.getDetail();
            } else {
              this.$message.error(res.data.error.message || '退回失败, 请重试')
            }
          })
          .catch((err) => {
            console.log(err)
          });
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
  }
}
</script>

<style scoped>
.aftersale-detail {
  padding: 0 20px;
}

.box-card {
  margin-bottom: 20px;
}

.clearfix {
  font-size: 16px;
  font-weight: 700;
}

.mgb15 {
  margin-bottom: 15px;
}

.mgr40 {
  margin-right: 40px;
}

.total-box {
  margin-top: 15px;
  text-align: right;
}

.btn-box {
  /* text-align: center; */
  margin-top: 20px;
}
</style>
